
import React, { useEffect, useRef, useState } from "react";
import "./style.css";

import { useStateContext } from "../../context/ContextProvider";
import {C_HeroData}  from"../../constants/index"
import { truncateText } from "../hooks/TextVeiw";
import GradiantButton from "../layout/GradiantButton";
import {IoIosArrowBack,IoIosArrowForward} from "../icons"
import SecondaryButton from "../layout/SecondaryButton";
import SmallButton from "../layout/SmallButton";
import { useTranslation } from "react-i18next";
const Carousel = () => {
  const carouselRef = useRef(null);
  const listRef = useRef(null);
  const thumbnailRef = useRef(null);
  const nextRef = useRef(null);
  const prevRef = useRef(null);
  const progressBarRef = useRef(null);
const {currentLang ,currentMode}=useStateContext()

  const timeRunning = 3000;
  const timeAutoNext = 7000;
  
  const runTimeOut = useRef(null);
  const runNextAuto = useRef(null);
  const progressInterval = useRef(null);

  const [currentSlide, setCurrentSlide] = useState(0);




  const startProgressBar = () => {
    if (progressBarRef.current) {
      progressBarRef.current.style.width = '0%';
      progressBarRef.current.style.animation = 'none';
      
      setTimeout(() => {
        progressBarRef.current.style.animation = `runningTime ${timeAutoNext}ms linear 1 forwards`;
      }, 50);
    }
  };

  const showSlider = (type) => {
    const carouselDom = carouselRef.current;
    const SliderDom = listRef.current;
    const thumbnailBorderDom = thumbnailRef.current;

    let SliderItemsDom = SliderDom.querySelectorAll(".item");
    let thumbnailItemsDom = thumbnailBorderDom.querySelectorAll(".item");

    if (type === "next") {
      SliderDom.appendChild(SliderItemsDom[0]);
      thumbnailBorderDom.appendChild(thumbnailItemsDom[0]);
      carouselDom.classList.add("next");
      setCurrentSlide((prev) => (prev + 1) % C_HeroData.length);
    } else {
      SliderDom.prepend(SliderItemsDom[SliderItemsDom.length - 1]);
      thumbnailBorderDom.prepend(thumbnailItemsDom[thumbnailItemsDom.length - 1]);
      carouselDom.classList.add("prev");
      setCurrentSlide((prev) => (prev - 1 + C_HeroData.length) % C_HeroData.length);
    }

    startProgressBar();

    clearTimeout(runTimeOut.current);
    runTimeOut.current = setTimeout(() => {
      carouselDom.classList.remove("next");
      carouselDom.classList.remove("prev");
    }, timeRunning);

    clearTimeout(runNextAuto.current);
    runNextAuto.current = setTimeout(() => {
      nextRef.current.click();
    }, timeAutoNext);
  };

  useEffect(() => {
    const nextDom = nextRef.current;
    const prevDom = prevRef.current;

    nextDom.onclick = () => showSlider("next");
    prevDom.onclick = () => showSlider("prev");


    runNextAuto.current = setTimeout(() => {
      nextDom.click();
    }, timeAutoNext);


    startProgressBar();

    return () => {
      clearTimeout(runTimeOut.current);
      clearTimeout(runNextAuto.current);
      clearInterval(progressInterval.current);
    };
  }, []);
  const {t}=useTranslation()

  return (
    <div className="slider-container mb-20  w-full overflow-hidden">
        
      <div className="slider lg:min-h-[800px]" ref={carouselRef}>

        <div className="list" ref={listRef}>
          {C_HeroData.map((slide, index) => (
            <div className="item" key={index}>
              <img src={currentMode === "Light"? slide.background:slide.background_dark}  alt={`Slide ${index + 1}`} />
              <div className="content"  dir={currentLang === "ar" ? "rtl" : "ltr"} >
           
              <div className=" h6 text-light-subtitle dark:text-dark-title ">{currentLang === "ar" ?slide.smallTitle_Ar :slide.smallTitle_En}</div>
              <div className="subtitle h1 my-3">{currentLang === "ar" ?slide.title_Ar :slide.title_En}</div>
                <div className=" h6 text-light-subtitle dark:text-dark-title  ">{currentLang === "ar" ?slide.subtitle_Ar :slide.subtitle_En}</div>
            
                <div className=" body-1 h-[68px] overflow-hidden md:h-auto text-light-text dark:text-dark-text">{currentLang === "ar" ?slide.description_Ar :slide.description_En}</div>
                <div className=" lg:mt-4 mt-2 ">
                    .
             
              
               <SecondaryButton textSize={"text-md font-kufi"} text={"LEARN MORE"}icon={currentLang === "en" ? <IoIosArrowForward size={20} /> : <IoIosArrowBack size={20}/>}  /></div>
           
              </div>
            </div>
          ))}
        </div>
      
<div className="flex-row items-center justify-between">

       <div dir="ltr" className="thumbnail bg-gradient-to-b backdrop:blur-xl from-light-glass1 dark:from-dark-glass1 to-light-glass2 dark:to-dark-glass2 border border-light-glassStrock2 dark:border-dark-glass2 shadow-md" ref={thumbnailRef}>
          {C_HeroData.map((slide, index) => (
            <div className="item" key={index}>
              <img src={slide.image}  alt={`Thumbnail ${index + 1}`} />
              <div dir={currentLang === "ar" ?"rtl" :"ltr"} className="content backdrop-blur-xl bg-gradient-to-b from-light-glass2 dark:from-dark-glass1 to-light-glass2 dark:to-dark-glass1 border border-light-glassStrock1 dark:border-dark-glass1 shadow-md">
                <div className={`text-xs font-kufi text-light-title dark:text-dark-title ${currentLang ==="ar" ? "text-right" : ""} `}>
              {" "} {currentLang === "ar" ?slide.subtitle_Ar :slide.subtitle_En}
                </div>
           
              </div>
            </div>
          ))}
        </div>

  
        <div className="arrows" dir={currentLang ==="ar" ?"rtl" :"ltr"}>
          <button  ref={prevRef} id="prev" aria-label="Previous slide">
         <SmallButton> {"<"}</SmallButton>  
          </button>
          <button ref={nextRef} id="next" aria-label="Next slide">
          <SmallButton>  {">"}</SmallButton>  
          
          </button>
        </div>

</div>
     

        <div className="progress-container">
          <div className="progress-bar" ref={progressBarRef}></div>
        </div>


        <div className="slide-indicator">
          {currentSlide + 1} / {C_HeroData.length}
        </div>
      </div>
    </div>
  );
};


const C_Hero = () => {
  return (
    <div><Carousel /></div>
  )
}

export default C_Hero